import { Image2d } from '../components/App/Viewer/renderer/Image2d/Image2d';
import { Image3d } from '../components/App/Viewer/renderer/Image3d/Image3d';
import { Waveform } from '../components/App/Viewer/renderer/ECG/Waveform';
import { Html } from '../components/App/Viewer/renderer/Html';
import { Void } from '../components/App/Viewer/renderer/Void/Void';
import { NotSupported } from '../components/App/Viewer/renderer/NotSupported/NotSupported';
import { toolbarVoid } from '../components/App/Viewer/renderer/Void/toolbarVoid';
import { toolbar2d } from '../components/App/Viewer/renderer/Image2d/toolbar2d';
import { toolbar3d } from '../components/App/Viewer/renderer/Image3d/toolbar3d';
import { toolbarECG } from '../components/App/Viewer/renderer/ECG/toolbarECG';
import { listOptions3D, cameras } from '../components/App/Viewer/renderer/Image3d/volumeInitOptions';
import * as SupportsInstances from './SupportsInstances';
import store from '../store/store';

export const RENDER_TYPE_2D = '2d';
export const RENDER_TYPE_3D = '3d';
export const RENDER_TYPE_ECG = 'waveform';
export const RENDER_TYPE_HTML = 'html';
export const RENDER_TYPE_VOID = undefined;
export const RENDER_TYPE_NOT_SUPPORTED = 'not supported';

export const factoryRenderers = () => {
  const { config } = store.getState((state) => state);
  return [
    {
      type: RENDER_TYPE_2D,
      Render: Image2d,
      ToolbarRender: toolbar2d,
      isOptions: true,
      description: '2D',
      isSupported: SupportsInstances.imageIsSupported,
    },
    ...(config.WITH_RENDER_3D
      ? [
          {
            type: RENDER_TYPE_3D,
            Render: Image3d,
            ToolbarRender: toolbar3d,
            isOptions: true,
            initOptions: listOptions3D,
            isSupported: SupportsInstances.image3dIsSupported,
            isTilted: SupportsInstances.image3dIsTilted,
          },
        ]
      : []),
    {
      type: RENDER_TYPE_ECG,
      Render: Waveform,
      ToolbarRender: toolbarECG,
      isOptions: false,
      isSupported: SupportsInstances.waveformIsSupported,
    },
    {
      type: RENDER_TYPE_HTML,
      Render: Html,
      ToolbarRender: toolbarVoid,
      description: 'HTML',
      isOptions: false,
      isSupported: SupportsInstances.documentIsSupported,
    },
    {
      type: RENDER_TYPE_VOID,
      Render: Void,
      ToolbarRender: toolbarVoid,
      isOptions: false,
      isSupported: () => false,
    },
    {
      type: RENDER_TYPE_NOT_SUPPORTED,
      Render: NotSupported,
      ToolbarRender: toolbarVoid,
      isOptions: false,
      isSupported: () => false,
    },
  ];
};

export const renderersByPriority = () => factoryRenderers.map((item) => item.render);
